var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-chat-box" }, [
    _vm._m(0),
    _c("div", { staticClass: "panel-body body-chat-box" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "div",
            { staticClass: "content-message" },
            [
              _vm.listComment.length > 0
                ? _vm._l(_vm.listComment, function(message) {
                    return _c(
                      "div",
                      {
                        key: message.ID,
                        staticClass: "message-item",
                        class: {
                          "my-message":
                            message.CustomerID === _vm.userInfo.userId
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "user",
                            class: { "text-danger": message.IsSystem == 1 }
                          },
                          [
                            _c("i", [
                              _vm._v(
                                _vm._s(
                                  (message.UserID > 0 || message.IsSystem == 1
                                    ? message.UserName
                                    : message.CustomerName) +
                                    ", " +
                                    message.CreatedDate
                                )
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "message",
                            class: { "text-danger": message.IsSystem == 1 }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(message.Comment) +
                                "\n                            "
                            )
                          ]
                        )
                      ]
                    )
                  })
                : _vm._e(),
              !_vm.listComment || _vm.listComment.length === 0
                ? [_vm._m(1)]
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "message-box" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comment,
                    expression: "comment"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.comment },
                on: {
                  keydown: function($event) {
                    return _vm.onCommentKeyup($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.comment = $event.target.value
                  }
                }
              }),
              _c(
                "a",
                {
                  staticClass: "btn btn-default",
                  attrs: { href: "javascript: void(0)" },
                  on: {
                    click: function($event) {
                      return _vm.addComment()
                    }
                  }
                },
                [_vm._v("Gửi")]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Chat với chúng tôi")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "none-message" }, [
      _c("i", { staticClass: "text-danger text-center" }, [
        _vm._v("Chat với chúng tôi để được hỗ trợ tốt nhất!")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }